<template>
    <v-container fluid>   
      <LeftMenu/>     

      <v-tabs
          v-model="tab"
          fixed-tabs          
          background-color="white"
          color="black accent-4"
          left
        >
          <v-tab key="stock">
            Stocks
          </v-tab>
          <v-tab key="section">
            Sections
          </v-tab>          
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
            key="stock"
          >
            <v-layout row wrap>   
              <v-flex xs1></v-flex>
              <v-flex xs10>
                <v-data-table
                  :headers="headersStock"
                  :items="stocks"
                  :items-per-page="50"
                  item-key="id"
                  sort-by="id"
                  :sort-desc=true
                  class="elevation-1"
                  :search="searchStock"
                  :custom-filter="filterOnlyCapsTextStock"
                  @dblclick:row="editStockItem"
                  >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Stock</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogStock" max-width="900px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">New Stock</v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitleStock }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedStockItem.code" label="Code"></v-text-field>
                                </v-flex> 
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedStockItem.name" label="Name"></v-text-field>
                                </v-flex>                                                                                                                                                                            
                              </v-layout>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" dark class="mb-2" @click="closeStockDialog">Cancel</v-btn>
                            <v-btn color="success" dark class="mb-2" @click="saveStock">Save</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-text-field v-model="searchStock" label="Search " class="mx-4"></v-text-field>
                  </template> 
                  <template v-slot:body.append>                    
                  </template>             
                  <template v-slot:item.action="{ item }">              
                    <v-icon                  
                      @click="editStockItem(item)">
                      mdi-table-edit
                    </v-icon>
                    <v-icon                  
                      @click="deleteStockItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-tab-item>

          <v-tab-item
            key="section"
          >
            <v-layout row wrap>   
              <v-flex xs1></v-flex>
              <v-flex xs10>
                <v-data-table
                  :headers="headersSection"
                  :items="categories"
                  :items-per-page="50"
                  item-key="id"
                  sort-by="id"
                  :sort-desc=true
                  class="elevation-1"
                  :search="searchSection"
                  :custom-filter="filterOnlyCapsText"
                  >
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Section</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialogSection" max-width="900px">
                        <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">New Section</v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm6 md12>
                                  <v-combobox
                                    :items="stocks"
                                    label="Stock"
                                    v-model="editedItem.stock"
                                    item-text="name"
                                    single-line
                                    return-object
                                  ></v-combobox>
                                </v-flex> 
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedItem.code" label="Code"></v-text-field>
                                </v-flex> 
                                <v-flex xs12 sm6 md6>
                                  <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                                </v-flex>                                                                                                                                                                                               
                              </v-layout>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" dark class="mb-2" @click="closeDialog">Cancel</v-btn>
                            <v-btn color="success" dark class="mb-2" @click="saveSection">Save</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                    <v-text-field v-model="searchSection" label="Search " class="mx-4"></v-text-field>
                  </template> 
                  <template v-slot:body.append>                    
                  </template>             
                  <template v-slot:item.action="{ item }">              
                    <v-icon                  
                      @click="editSection(item)">
                      mdi-table-edit
                    </v-icon>
                    <v-icon                  
                      @click="deleteSection(item)"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs1></v-flex>
            </v-layout>
          </v-tab-item>


        </v-tabs-items>  
    </v-container>
</template>
<script>
import LeftMenu from '../../components/LeftMenu';
const STOCK_API_URL = 'stock/stocks';
const SECTION_API_URL = 'stock/stockSections';
export default {
    components:{
      LeftMenu
    },
    data () {
    return {
      tab: null,
      dialogStock: false,
      dialogSection: false,
      searchStock: '',
      searchSection: '',
      stocks: [],
      categories: [  ],
      formTitleStock: 'New Stock',
      formTitle: 'New Section',
      editedStockIndex: -1,
      editedIndex: -1,
      editedStockItem: { },
      editedItem: { },
      defaultItem: {},
    }
  },
  computed: {
    headersStock () {
      return [
        { text: 'Stock Code', align: 'left', sortable: true, value: 'code'},
        { text: 'Stock name',  value: 'name'  }, 
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    headersSection () {
      return [
        { text: 'Stock Name', align: 'left', sortable: true, value: 'stock.name'},
        { text: 'Section Code', align: 'left', sortable: true, value: 'code'},
        { text: 'Section Name', align: 'left', sortable: true, value: 'name'  }, 
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },
    categoriesFormatted(){
      return this.categories.map((item) => {
        if(item.stock){
          item.textFormatted = item.stock.text +' - '+ item.text;
        }
        return item;  
      })
    },
    subCategoriesFormatted(){
      return this.subCategories.map((item) => {
        if(item.section && item.section.stock){
          item.section.textFormatted = item.section.stock.text +' - '+ item.section.text;
        }
        return item;  
      })
    },
  },
  created() {    
    this.getStocks();   
    this.getCategories();
  },
  watch: {
    dialogStock (val) {
      val || this.closeStockDialog()
    },
    dialogSection (val) {
      val || this.closeDialog()
    },
  },
  methods: {
    editStockItem (item) {
      this.editedStockIndex = this.stocks.indexOf(item)
      this.editedStockItem = Object.assign({}, item)

      console.log(this.editedStockIndex);
      this.formTitleStock = 'Edit Stock';
      this.dialogStock = true
    },

    deleteStockItem (item) {
      const index = this.stocks.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.stocks.splice(index, 1);
        this.deleteStock(item);
      } 
    },

    editSection (item) {
      this.editedIndex = this.categories.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.formTitle = 'Edit Section';
      this.dialogSection = true
    },

    deleteSection (item) {
      const index = this.categories.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.categories.splice(index, 1);
        this.deleteSection(item);
      } 
    },

    closeStockDialog () {
      this.dialogStock = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedStockIndex = -1
      }, 300)
    },
    closeDialog () {
      this.dialogSection = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    saveStock () {
      if (this.editedStockIndex > -1) {        
        this.updateStock(this.editedStockItem);
      } else {
        this.addStock(this.editedStockItem);         
      }      
    },
    saveSection () {
      if (this.editedIndex > -1) {        
        this.updateSection(this.editedItem);
      } else {
        this.addSection(this.editedItem);         
      }      
    },
    addStock(item){
      this.$axios.post(this.$apiurl + STOCK_API_URL, {
        code: item.code,
        name: item.name
      })
      .then(response => {        
        if (response.status === 201) {
          this.stocks.push(this.editedStockItem);
          this.$radio.$emit('success', {message:'Stock Added Successfully'});
          this.closeStockDialog();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateStock(item){
      this.$axios.put(this.$apiurl + STOCK_API_URL, {
        id: item.id,
        code: item.code,
        name: item.name
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.stocks[this.editedStockIndex], this.editedStockItem);
          this.$radio.$emit('success', {message:'Stock Updated Successfully'});
          this.closeStockDialog();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteStock(item){
      this.$axios.delete(this.$apiurl + STOCK_API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getStocks(){     
      this.$axios.get(this.$apiurl + STOCK_API_URL)
        .then(response => {
            this.stocks = response.data
        }) 
        .catch(error => {        
          console.log(error);
        });                         
    },
    addSection(item){
      this.$axios.post(this.$apiurl + SECTION_API_URL, {
        stockId : this.editedItem.stock.id,
        code: item.code,
        name: item.name
      })
      .then(response => {        
        if (response.status === 201) {
          this.categories.push(this.editedItem);
          this.$radio.$emit('success', {message:'Section Added Successfully'});
          this.closeDialog();
        } 
      }).catch(error => {        
          console.log(error);
        }); 
    },
    updateSection(item){
      this.$axios.put(this.$apiurl + SECTION_API_URL, {
        id: item.id,
        stockId : this.editedItem.stock.id,
        code: item.code,
        name: item.name
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.categories[this.editedIndex], this.editedItem);
          this.$radio.$emit('success', {message:'Section Updated Successfully'});
          this.closeDialog();
        }         
      }).catch(error => {        
          console.log(error);
        }); 
    },
    deleteSection(item){
      this.$axios.delete(this.$apiurl + SECTION_API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getCategories(){     
      this.$axios.get(this.$apiurl + SECTION_API_URL)
        .then(response => {
            this.categories = response.data
        }) 
        .catch(error => {        
          console.log(error);
        });                         
    },
    filterOnlyCapsTextStock (value, searchStock) {
      return value != null &&
        searchStock != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(searchStock.toLocaleUpperCase()) !== -1
    },
    filterOnlyCapsText (value, searchSection) {
      return value != null &&
        searchSection != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(searchSection.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
